export default "__VITE_ASSET__DpudIwzZ__"